import { executeQuery, executeQuerySync } from './AppSyncPlusAPIs';

export const getAutomatedAppsByOwner = (appOwner, status, onSuccess, onFailure) => {
  const fetchAll = async () => {
    let allItems = [];
    let nextToken = null;

    do {
      const statusFilter = status ? `, status: "${status}"` : '';
      const tokenArg = nextToken ? `, nextToken: "${nextToken}"` : '';
      const qry = `query MyQuery {
        getAutomatedAppsByOwner(app_owner: "${appOwner}"${statusFilter}${tokenArg})
      }`;
      const response = await executeQuerySync(qry);
      const data = response?.data?.getAutomatedAppsByOwner;
      if (data) {
        const parsed = typeof data === 'string' ? JSON.parse(data) : data;
        const items = parsed.items || parsed.Items || [];
        allItems = allItems.concat(items);
        nextToken = parsed.nextToken || null;
        // Progressive update: notify for intermediate results only
        if (onSuccess && nextToken) {
          onSuccess({ data: { getAutomatedAppsByOwner: JSON.stringify({ items: allItems }) }, loading: true });
        }
      } else {
        nextToken = null;
      }
    } while (nextToken);

    // Final call with loading=false
    if (onSuccess) onSuccess({ data: { getAutomatedAppsByOwner: JSON.stringify({ items: allItems }) }, loading: false });
  };

  fetchAll().catch((err) => {
    if (onFailure) onFailure(err);
  });
};

export const getAutomatedAppsByStatus = (status, onSuccess, onFailure) => {
  const fetchAll = async () => {
    let allItems = [];
    let nextToken = null;

    do {
      const tokenArg = nextToken ? `, nextToken: "${nextToken}"` : '';
      const qry = `query MyQuery {
        getAutomatedAppsByStatus(status: "${status}"${tokenArg})
      }`;
      const response = await executeQuerySync(qry);
      const data = response?.data?.getAutomatedAppsByStatus;
      if (data) {
        const parsed = typeof data === 'string' ? JSON.parse(data) : data;
        const items = parsed.items || parsed.Items || [];
        allItems = allItems.concat(items);
        nextToken = parsed.nextToken || null;
        // Progressive update: notify for intermediate results only
        if (onSuccess && nextToken) {
          onSuccess({ data: { getAutomatedAppsByStatus: JSON.stringify({ items: allItems }) }, loading: true });
        }
      } else {
        nextToken = null;
      }
    } while (nextToken);

    // Final call with loading=false
    if (onSuccess) onSuccess({ data: { getAutomatedAppsByStatus: JSON.stringify({ items: allItems }) }, loading: false });
  };

  fetchAll().catch((err) => {
    if (onFailure) onFailure(err);
  });
};

export const getAutomatedAppsByOwnerSync = async (appOwner, status) => {
  let allItems = [];
  let nextToken = null;

  do {
    const statusFilter = status ? `, status: "${status}"` : '';
    const tokenArg = nextToken ? `, nextToken: "${nextToken}"` : '';
    const qry = `query MyQuery {
      getAutomatedAppsByOwner(app_owner: "${appOwner}"${statusFilter}${tokenArg})
    }`;
    const response = await executeQuerySync(qry);
    const data = response?.data?.getAutomatedAppsByOwner;
    if (data) {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data;
      const items = parsed.items || parsed.Items || [];
      allItems = allItems.concat(items);
      nextToken = parsed.nextToken || null;
    } else {
      nextToken = null;
    }
  } while (nextToken);

  return { data: { getAutomatedAppsByOwner: JSON.stringify({ items: allItems }) } };
};

export const updateAutomatedApp = (input, onSuccess, onFailure) => {
  const qry = `mutation MyMutation($input: AWSJSON!) {
    updateAutomatedApp(input: $input)
  }`;
  executeQuery(qry, onSuccess, onFailure, { input: JSON.stringify(input) });
};
